import { use } from 'react';

import { useTranslation } from 'react-i18next';

import { Card } from '~components';
import OrganisationContext from '~features/organisations/providers/organisationDetailsContext';
import ScheduledActionsDataGrid from '~features/scheduledActions/components/dataGrids/scheduledActionsDataGrid';

import OrganisationActionBar from '../../organisations/components/organisationActionBar';

const OrganisationScheduledActionsContainer = () => {
	const { t } = useTranslation('entities');
	const organisationContext = use(OrganisationContext);
	const organisationId = organisationContext.organisation?.id ?? '0';

	return (
		<>
			<OrganisationActionBar organisationId={organisationId} showEditButton={false} />
			<Card title={t('schedule.labels.plural')} sx={{ height: '100%' }}>
				<ScheduledActionsDataGrid source={'organisation'} overwrittenClientId={organisationId} />
			</Card>
		</>
	);
};

export default OrganisationScheduledActionsContainer;
